// KPICard.jsx — card de KPI usado no topo das telas
//
// <KPICard icon="📅" iconBg="#FDEBE3" iconColor="#F15D22"
//          label="Visitas do dia" valor={42} total={42}
//          sub="100% realizadas" barColor="#F15D22" barPct={100} />

export default function KPICard({
  icon, iconBg = '#FDEBE3', iconColor = '#F15D22',
  label, valor, total, sub, subTrend, // subTrend: 'up' | 'down' | null
  barColor, barPct,
}) {
  return (
    <div className="kpi-card">
      <div className="kpi-card-head">
        <div className="kpi-icon" style={{ background: iconBg, color: iconColor }}>{icon}</div>
        <div className="kpi-label">{label}</div>
      </div>
      <div className="kpi-value">
        {valor}
        {total != null && <span className="total"> / {total}</span>}
      </div>
      {sub && <div className={`kpi-sub${subTrend ? ' ' + subTrend : ''}`}>{sub}</div>}
      {barPct != null && (
        <div className="kpi-bar">
          <div className="kpi-bar-fill" style={{ width: `${barPct}%`, background: barColor || 'var(--laranja)' }}/>
        </div>
      )}
    </div>
  );
}
